<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<p class="toc-ttl"><span epub:type="pagebreak" id="page_viii" title="viii">CONTENTS</span></p>
<p class="toc1"><a href="#/frontmatter02#pz9-2_1" id="pz9-2"><i>Foreword by Duane “Dog the Bounty Hunter” Chapman</i></a></p>
<p class="toc"><a href="#/chapter01#A49_1" id="A49"><b>Chapter 1</b> Take Up Serpents</a></p>
<p class="toc"><a href="#/chapter02#AWQ_1" id="AWQ"><b>Chapter 2</b> The Religious Spirit and Idols</a></p>
<p class="toc"><span href="#/chapter03#AqN_1" id="AqN" title="Link target outside of Sample"><b>Chapter 3</b> Snakes Hate Fire</span></p>
<p class="toc"><span href="#/chapter04#AFX_1" id="AFX" title="Link target outside of Sample"><b>Chapter 4</b> The Antivenom Power of Jesus</span></p>
<p class="toc"><span href="#/chapter05#pz9-3_1" id="pz9-3" title="Link target outside of Sample"><b>Chapter 5</b> Shaking Off Venomous Vipers Through Communion</span></p>
<p class="toc"><span href="#/chapter06#pz9-5_1" id="pz9-5" title="Link target outside of Sample"><b>Chapter 6</b> Leviathan: The King of the Children of Pride</span></p>
<p class="toc"><span href="#/chapter07#pz9-7_1" id="pz9-7" title="Link target outside of Sample"><b>Chapter 7</b> Trauma, Leviathan, and Witchcraft</span></p>
<p class="toc"><span href="#/chapter08#pz9-8_1" id="pz9-8" title="Link target outside of Sample"><b>Chapter 8</b> Python Squeezes Out Your Gains</span></p>
<p class="toc"><span href="#/chapter09#pz9-9_1" id="pz9-9" title="Link target outside of Sample"><b>Chapter 9</b> Healing and Deliverance From Idols</span></p>
<p class="toc"><span href="#/chapter10#pz9-10_1" id="pz9-10" title="Link target outside of Sample"><b>Chapter 10</b> Fertility and Food</span></p>
<p class="toc"><span href="#/chapter11#pz9-11_1" id="pz9-11" title="Link target outside of Sample"><b>Chapter 11</b> Commissioned to Be a Snake Hunter</span></p>
<p class="toc1"><span href="#/chapter12#pz9-12_1" id="pz9-12" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc1"><span href="#/bm#pz9-13_1" id="pz9-13" title="Link target outside of Sample"><i>About the Author</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-toc.vue?7080f29d